import { TableCellType } from "@/constants/table/table"
import { WorkflowExecution } from "@/types/workflowHistory"
import { ColumnDef } from "@tanstack/react-table"

export const workflowRunHistoryColumns: ColumnDef<WorkflowExecution>[] = [
  {
    accessorKey: "status",
    header: "Status",
    meta: { type: TableCellType.WORKFLOW_RUN_STATUS },
  },
  {
    accessorKey: "id",
    header: "Run ID",
    meta: { type: TableCellType.LINK_BUTTON },
  },
  {
    accessorKey: "runDate",
    header: "Run Date",
    meta: { type: TableCellType.DATE },
  },
  {
    accessorKey: "type",
    header: "Type",
    meta: { type: TableCellType.TEXT },
  }
]
